import { useTranslation } from 'react-i18next'
import { Modal } from '~/shared/ui/Modal'
import { Form } from './Form'
import { FormValues } from './model'

type DepositRepaymentModalProps = {
  isShow: boolean
  onOk: (formValues: FormValues) => void
  onCancel: () => void
  isSubmitting: boolean
  depositBalance: number
  debtBalance: number
}

export function DepositRepaymentModal({
  isShow,
  onOk,
  onCancel,
  isSubmitting,
  depositBalance,
  debtBalance,
}: DepositRepaymentModalProps) {
  const { t } = useTranslation()
  return (
    <Modal
      isShow={isShow}
      onCancel={isSubmitting ? undefined : onCancel}
      title={t('deposit repayment')}
      dialogProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '600px',
        },
      }}
    >
      <Form
        onSuccess={onOk}
        isSubmitting={isSubmitting}
        depositBalance={depositBalance}
        debtBalance={debtBalance}
      />
    </Modal>
  )
}
